import { render } from "./SettingView.vue?vue&type=template&id=f2ac37d0&scoped=true"
import script from "./SettingView.vue?vue&type=script&lang=js"
export * from "./SettingView.vue?vue&type=script&lang=js"

import "@/assets/css/setting.css?vue&type=style&index=0&id=f2ac37d0&lang=css&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2ac37d0"]])

export default __exports__